<template>
    <header class="">
        <div class="container flex">
            <router-link class="logo" :title="'Trim Editor v' + appVersion" :to="'/'">
                <img :src="`${publicPath}imgs/DST logo.png`" alt="DST Logo">
            </router-link>

            <UserCabinet class="user-cabinet"></UserCabinet>
        </div>
    </header>
</template>

<script>
    import { mapState } from 'vuex';
    import UserCabinet from "../authentication/userCabinet/UserCabinet";

    export default {
        name: "SiteHeader",

        components: {
            UserCabinet,
        },

        computed: {
            ...mapState([
                'publicPath',
                'appVersion',
            ]),

        },

    }
</script>

<style scoped>
    header {
        align-items: center;
    }

    .logo {
        margin-right: auto;
        font-size: 30px;
        font-weight: 700;
        text-decoration: none;
        color: inherit;
    }

    img {
        width: 200px;
        height: 60px;
        margin: 5px 0 0;
    }

    .user-cabinet {
        margin: 20px 0;
    }

    button {
        margin-left: auto;
    }
</style>